import React, {useCallback, useEffect, useState} from "react";
import {Link, useHistory, useParams, useRouteMatch} from "react-router-dom";
import BlockCustomDialog from "./BlockCustomDialog";
import {useMutation} from "react-query";
import {createTeacherPlayList, recentAddedPlayList, removePlaylistContent} from "../../api/playlist";
import {IoMdArrowBack} from "react-icons/io";
import {AiOutlineDelete} from "react-icons/ai";
import {MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank} from "react-icons/md";
import PropTypes from "prop-types";

const CheckBoxControl = ({checked, onChange}) => {
    return !checked ? (
        <MdOutlineCheckBoxOutlineBlank
            onClick={() => onChange(!checked)}
            size={20}
            color="white"
            className="mr-2"
        />
    ) : (
        <MdOutlineCheckBox
            size={20}
            onClick={() => onChange(!checked)}
            color="white"
            className="mr-2"
        />
    );
};


export default function BlockRemovePlayListContentData() {

    const history = useHistory();
    const [selecting, setSelecting] = useState(false);
    const [openDeleteDialog, setDeleteDialog] = useState(false);
    const [listContent, _listContent] = useState([]);
    const {url} = useRouteMatch();
    const param = useParams();
    const playlistId = `${param.id}`;
    const playlistID = `${param.id}/`;
    const splitData = url.split('/')
    const newUrl = splitData.slice(0, 4).join('/');
    const [playlists, setPlaylists] = useState([]);

    const fetchPlaylistContent = () => {
        recentAddedPlayList(playlistID).then(res => {
            const data = res.data.body.content;
            if (data?.length > 0) {
                _listContent(data);
            } else {
                _listContent([]);
            }
        }).catch(error => console.log("error", error));
    }

    useEffect(() => {
        try {
            fetchPlaylistContent();
        } catch (error) {
            console.log("error", error);
        }
    }, []);

    /** add the isSelect attribute for check and unCheck the content*/
    useEffect(() => {
        const newPlayLists = listContent.map((playList) => ({
            ...playList,
            isSelected: false,
        }));
        setPlaylists(newPlayLists);
    }, [listContent]);

    const toggleSelecting = () => setSelecting(!selecting);

    /** selection of content data*/
    const toggleSelection = (checked, index) => {
        const newPlayLists = playlists.map((playlist, i) => {
            if (i === index) return {...playlist, isSelected: checked};
            return playlist;
        });

        setPlaylists(newPlayLists);
    };

    const isAnySelected = playlists.some(playlist => playlist.isSelected)
    const goBack = useCallback(() => history.goBack(), []);

    /** query used to create the teacher playlist*/
    const {
        isLoading: isCreating,
        error: createError,
        isError: isCreateError,
        mutate,
        data
    } = useMutation(createTeacherPlayList, {
        onSuccess: (data, variables) => {
            if (data?.status === 201) {
                const playlistData = data.data.body;
                const id = playlistData.id;
                const title = playlistData.title;
                history.push({
                    pathname: `${url}/playlist`,
                    state: {
                        id: id,
                        title: title
                    }
                });
            } else {
                history.push(`${newUrl}/`);
            }
        },
        onError: (err) => {
            console.log(err);
        },
    });

    /** remove Content from the playlist*/
    const {
        mutate: removeContentFromPlaylist,
    } = useMutation(removePlaylistContent, {
        onSuccess: (data, variables) => {
            if (data?.status === 201) {
                // history.push(`${newUrl}/playlist/${playListTitle}`);
                setDeleteDialog(false);
                fetchPlaylistContent();
            }
        },
        onError: (err) => {
            console.log(err);
            setDeleteDialog(false);
        },
    });

    /** remove the content from playlist*/
    const removeContentData = () => {
        const filterData = playlists.filter((item) => item?.isSelected === true);

        if (filterData?.length > 0) {
            const removeData = filterData?.map((item) => {
                return {
                    id: playlistId,
                    sourceId: item?.id,
                }
            });
            removeContentFromPlaylist({playlistId: playlistId, removeContent: removeData});
        }
    }

    /** goToAddContentPage*/
    const goToAddContent = () => {
        history.push(`${newUrl}/select-content/${playlistId}`);
    }

    return (
        <>
            <div className="flex items-center justify-between">
                <div className="flex items-center">
                    <IoMdArrowBack
                        onClick={goBack}
                        size={30}
                        className="mr-3 cursor-pointer"
                    />
                    <h4 className="text-xl flex-auto">My Playlists</h4>
                </div>
                <div className="flex items-center gap-x-3">
                    <button
                        onClick={toggleSelecting}
                        className="font-bold text-lg font-[Poppins-Bold]"
                    >
                        {selecting ? "Cancel" : "Select"}
                    </button>
                    {
                        isAnySelected && selecting &&
                        <button
                            onClick={() => setDeleteDialog(true)}
                            className="font-bold text-lg font-[Poppins-Bold]"
                        >
                            <AiOutlineDelete size={25}/>
                        </button>
                    }
                </div>
            </div>

            <div className="flex flex-col flex-auto justify-between">
                <div className="flex-auto ">
                    {playlists?.length > 0 ?
                        <div
                            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 h-full overflow-y-auto mt-2 ">
                            {playlists.map((item, index) => (
                                <div className="w-full  overflow-hidden" key={index}>
                                    <div
                                        className="rounded w-full aspect-video bg-cover flex flex-col justify-between"
                                        style={{
                                            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0)), url(${item?.thumbnail})`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                        }}
                                    >
                                        <div className="flex justify-end pr-1 pt-1">
                                            {selecting ? (
                                                <CheckBoxControl
                                                    checked={item.isSelected}
                                                    onChange={(checked) => toggleSelection(checked, index)}
                                                />
                                            ) : null}
                                        </div>
                                        <div className="flex items-center gap-2 ml-2">
                                            <img
                                                src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png"
                                                className="h-5 w-5"
                                                alt=""
                                            />
                                            <span className="text-white text-xs">{item?.source}</span>
                                        </div>
                                    </div>
                                    <p className="truncate text-sm mt-2.5">
                                        {item?.title}
                                    </p>
                                </div>
                            ))}
                            <div className="w-full  overflow-hidden flex justify-center items-center">
                                <span className="icon icon-plus-circle text-gray-400 text-5xl"
                                      onClick={() => goToAddContent()}></span>
                            </div>
                        </div> : <div className="flex justify-center">
                            <h3>Play list not available</h3>
                        </div>}
                </div>
                <Link to={`${newUrl}/playlists`} className="ml-auto text-sm underline">View playlist</Link>
            </div>

            <BlockCustomDialog
                targetId="contentWrapperBox"
                open={openDeleteDialog}
                onClose={() => setDeleteDialog(false)}
                overlayClasses="justify-center items-center backdrop-blur-md"
            >
                <div className="w-96 flex flex-col rounded-full p-4">
                    <h4 className="text-lg font-bold text-center">
                        Delete content
                    </h4>
                    <div className="mt-3 mb-6">
                        <p className="text-center px-4">Are you sure you want to delete this content?</p>
                    </div>
                    <div className="flex gap-x4">
                        <button onClick={() => removeContentData()}
                                className="w-40 mx-auto px-10 py-2 text-black border-2 border-black font-extrabold font-[Poppins-Bold] rounded-lg">
                            Yes
                        </button>
                        <button onClick={() => setDeleteDialog(false)}
                                className="w-40 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                            No
                        </button>
                    </div>
                </div>
            </BlockCustomDialog>
        </>
    );
}
CheckBoxControl.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func
}
